import { useFetchData } from "../../../hooks/useFetch";
import {
  ApiConfig,
  API_ATTENDANCE_SCHEDULE_ASSIGNMENT_ROUTER,
  API_WORK_SCHEDULE_TEMPLATE_ROUTER,
} from "../../../services/api-config";

/** 1 ngày trong tuần của lịch làm việc cố định. weekday: 2=T2 ... 7=T7, 8=CN (khớp BE). */
export interface ScheduleDayConfig {
  weekday: number;
  start_time: string; // HH:mm
  end_time: string; // HH:mm
  is_working: number; // 1 = ngày làm việc, 0 = ngày nghỉ tuần
}

export interface WorkScheduleTemplate {
  id: number;
  name: string;
  description: string;
  status: number;
  days_parsed: ScheduleDayConfig[];
}

export enum SCHEDULE_ASSIGNMENT_SCOPE {
  DEFAULT = 1,
  DEPARTMENT = 2,
  EMPLOYEE = 3,
}

export interface AttendanceScheduleAssignment {
  id: number;
  scope_type: SCHEDULE_ASSIGNMENT_SCOPE;
  scope_id: number;
  schedule_template_id: number;
  /** NULL = dùng tọa độ trụ sở chính (Cài đặt chung). */
  work_branch_id: number | null;
  note: string;
}

export interface ModifyWorkScheduleTemplatePayload {
  name: string;
  description: string;
  days: ScheduleDayConfig[];
}

export interface UpsertAssignmentPayload {
  scope_type: SCHEDULE_ASSIGNMENT_SCOPE;
  scope_id?: number;
  schedule_template_id: number;
  work_branch_id?: number | null;
  note?: string;
}

const WorkScheduleService = {
  listTemplates: () => {
    const { request, baseResponse, loading } = useFetchData.Get<WorkScheduleTemplate[]>({
      projectId: ApiConfig.PROJECT_ID.HRM_SERVICE,
    });
    return {
      fetch: () => request({ endPoint: API_WORK_SCHEDULE_TEMPLATE_ROUTER.API_LIST }),
      response: baseResponse,
      loading,
    };
  },

  createTemplate: () => {
    const { request, baseResponse, loading } = useFetchData.Post<WorkScheduleTemplate>({
      projectId: ApiConfig.PROJECT_ID.HRM_SERVICE,
    });
    return {
      fetch: (payload: ModifyWorkScheduleTemplatePayload) =>
        request({ endPoint: API_WORK_SCHEDULE_TEMPLATE_ROUTER.API_CREATE, data: payload }),
      response: baseResponse,
      loading,
    };
  },

  updateTemplate: () => {
    const { request, baseResponse, loading } = useFetchData.Post<WorkScheduleTemplate>({
      projectId: ApiConfig.PROJECT_ID.HRM_SERVICE,
    });
    return {
      fetch: (id: number, payload: ModifyWorkScheduleTemplatePayload) =>
        request({ endPoint: API_WORK_SCHEDULE_TEMPLATE_ROUTER.API_UPDATE(id), data: payload }),
      response: baseResponse,
      loading,
    };
  },

  detailTemplate: () => {
    const { request, baseResponse, loading } = useFetchData.Get<WorkScheduleTemplate>({
      projectId: ApiConfig.PROJECT_ID.HRM_SERVICE,
    });
    return {
      fetch: (id: number) => request({ endPoint: API_WORK_SCHEDULE_TEMPLATE_ROUTER.API_DETAIL(id) }),
      response: baseResponse,
      loading,
    };
  },

  listAssignments: () => {
    const { request, baseResponse, loading } = useFetchData.Get<AttendanceScheduleAssignment[]>({
      projectId: ApiConfig.PROJECT_ID.HRM_SERVICE,
    });
    return {
      fetch: (params?: { scope_type?: SCHEDULE_ASSIGNMENT_SCOPE }) =>
        request({ endPoint: API_ATTENDANCE_SCHEDULE_ASSIGNMENT_ROUTER.API_LIST, data: params }),
      response: baseResponse,
      loading,
    };
  },

  upsertAssignment: () => {
    const { request, baseResponse, loading } = useFetchData.Post<AttendanceScheduleAssignment>({
      projectId: ApiConfig.PROJECT_ID.HRM_SERVICE,
    });
    return {
      fetch: (payload: UpsertAssignmentPayload) =>
        request({ endPoint: API_ATTENDANCE_SCHEDULE_ASSIGNMENT_ROUTER.API_UPSERT, data: payload }),
      response: baseResponse,
      loading,
    };
  },
};

export default WorkScheduleService;
